// extracted by mini-css-extract-plugin
export default {"container":"signInOrRegister_container__DQ7t7","secondaryLink":"signInOrRegister_secondaryLink__5QKlI"};